// extracted by mini-css-extract-plugin
module.exports = {"root":"GrammarOption_root__28c1N","input":"GrammarOption_input__pbiel","deleteButton":"GrammarOption_deleteButton__1EYVI"};